<!--选择excle文件并上传页面-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin: 20px;text-align: right;font-weight: bold;font-size:16px;margin-right: 30px;cursor: pointer;"
          @click="backToHome()">
          <返回 </div>


            <div style="padding: 10px;">
              <div>
                <div style="text-align: center;margin: 20px;font-size:22px;">重设《{{form_name}}》查询条件</div>
              </div>
              <div>
                <div style="margin-left: 20px;margin-top: 20px;">
                  <div style="font-size: 16px;display: flex;justify-content: center;"><span
                      style="margin-bottom: 10px;">*请从左框中查询条件列(如姓名,身份证等,最多两个)选到右侧框中.</span></div>
                  <div style="font-size: 16px;margin-top: 5px;display: flex;justify-content: center;"><span
                      style="color:red;margin-bottom: 10px;">特别注意:必须选择每个人都有数据的列,否则部分人将无法查询</span></div>
                  <div style="text-align: left;display: flex;margin-top: 10px;justify-content: center;">
                    <el-transfer target-order="push" v-model="selectedSearchCondition" :data="transferList"
                      :titles="['可以选用的列','用于查询的列']">
                    </el-transfer>
                  </div>
                </div>


              </div>

              <div style="display: flex;justify-content: center;margin-top: 40px;">

                <el-button size="medium" type="primary" style="width: 400px;"
                  @click="saveCondition()">完成设置，立即保存</el-button>
              </div>

            </div>
      </el-col>
    </el-row>


  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        form_id: '',
        form_name: '',
        conditions: [],
        fields: [],
        transferList: [],
        selectedSearchCondition: [],
        message: ''
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      // console.log('调用exam_list created')
      // this.loadCourses()
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      // console.log('dddddddddddd',this.form_id,this.form_name)
      this.loadConditions()
    },
    methods: {
      loadConditions() {
        let that = this

        // 调用删除接口
        var requestUrl = '/wansearch/web/_load_condition_value_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              query_id: that.form_id,
            }
          }).then(function(response) {
            // console.log('$$$$$$$$$$$',response.data)
            that.fields = response.data.field_list

            that.transferList = []
            for (var i = 0; i < that.fields.length; i++) {
              let item = {
                key: that.fields[i].field_name,
                label: that.fields[i].field_name,
                disabled: false
              }
              that.transferList.push(item)
            }

            var tmpList = response.data.conditions
            that.selectedSearchCondition = []
            for (var i = 0; i < tmpList.length; i++) {
              var str = tmpList[i].condition_name
              that.selectedSearchCondition.push(str)
            }



          })
          .catch(function(error) {
            console.log(error)
          })
      },
      saveCondition() {

        console.log('开始保存', this.selectedSearchCondition)

        if (this.selectedSearchCondition.length === 0) {
          this.message = '至少选一个查询条件,如姓名、工号、学号等(最多2个)'
          this.$alert(this.message)
          return
        }

        if (this.selectedSearchCondition.length > 2) {
          this.message = '不要超过2个查询条件(最多2个),否则录入会很困难,请重新选择！'
          this.$alert(this.message)
          return
        }


        let that = this

        var jsonStr = JSON.stringify(this.selectedSearchCondition)

        // 调用删除接口
        var requestUrl = '/wansearch/web/_reset_condition_save.jsp'
       let data = {
         conditions: jsonStr,
         form_id: that.form_id
       }

       // console.log('head_list====', that.headList)

       var qs = require('qs')

       // 开启loading
       const load = this.$loading({
         lock: true,
         text: '正在导入,请稍候...',
         spinner: 'el-icon-loading',
         background: 'rgba(0, 0, 0, 0.7)'
       })

       this.axios.post(
           requestUrl,
           qs.stringify(data), {
             headers: {
               'Content-Type': 'application/x-www-form-urlencoded'
             }
           }
         ).then(function(response) {
           that.$message({
             duration: 5000,
             message: '保存成功！',
             type: 'success'
           })
           load.close()

             that.$router.push({
               path: '/query_list',
               params: {
                 username: that.username
               }
             })
         })
         .catch(function(error) {
           console.log(error)
           load.close()
         })


      },
      backToHome() {
        this.$router.go(-1)
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  .uploadFileStyle {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/reset_query_conditions.vue